
  var _styles = {
  "top-radius": {
    "width": "0.2rem",
    "height": "0.2rem",
    "borderRadius": "50%",
    "position": "absolute",
    "left": "3.2rem",
    "top": "-0.13333rem",
    "zIndex": 1
  },
  "bottom-radius": {
    "width": "0.2rem",
    "height": "0.2rem",
    "borderRadius": "50%",
    "position": "absolute",
    "left": "3.2rem",
    "bottom": "-0.13333rem",
    "zIndex": 1
  },
  "price-logo": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": "0.10667rem",
    "backgroundColor": "rgb(255,255,255)",
    "height": "1.6rem",
    "fontSize": "0.37333rem",
    "lineHeight": "0.53333rem",
    "color": "rgb(51,51,51)",
    "position": "relative"
  },
  "font-white": {
    "color": "rgb(255,255,255)",
    "fontSize": "0.32rem"
  },
  "price": {
    "fontSize": "0.37333rem"
  },
  "left-content": {
    "height": "100%",
    "paddingTop": "0.28rem",
    "paddingRight": 0,
    "paddingBottom": "0.28rem",
    "paddingLeft": "0.21333rem",
    "width": "3.30667rem"
  },
  "city": {
    "fontSize": "0.34667rem",
    "width": "3.09333rem",
    "overflow": "hidden",
    "textOverflow": "ellipsis",
    "whiteSpace": "nowrap"
  },
  "right-content": {
    "height": "100%",
    "width": "1.28rem",
    "paddingTop": "0.28rem",
    "paddingRight": 0,
    "paddingBottom": "0.28rem",
    "paddingLeft": 0,
    "textAlign": "center",
    "borderTopRightRadius": "0.10667rem",
    "borderBottomRightRadius": "0.10667rem",
    "fontWeight": "200"
  },
  "font-grey": {
    "color": "rgb(153,153,153)",
    "fontSize": "0.32rem"
  }
};



  module.exports = _styles;
  